import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { FeatureService } from 'shared/services';

@Injectable()
export class FeatureGuard {
    constructor(
        private featureService: FeatureService,
        private router: Router
    ) {}

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (
            (await this.featureService.isFeatureEnabled(route.data.requiredFeature)) ||
            !(await this.featureService.isFeatureEnabled(route.data.excludedFeature))
        ) {
            return true;
        }

        this.router.navigate(['/']);
        return false;
    }
}
